import type { DmpModificationEntry } from '@uniticket/shared';

interface DmpFieldWithDiffProps {
  label: string;
  value: string;
  mono?: boolean;
  modification?: DmpModificationEntry;
}

export function DmpFieldWithDiff({ label, value, mono, modification }: DmpFieldWithDiffProps) {
  return (
    <div>
      <div className="flex items-center gap-1.5 mb-0.5">
        <p className="text-[10px] font-bold uppercase tracking-wider text-slate-400">{label}</p>
        {modification && (
          <span
            className="inline-flex items-center px-1.5 py-0 rounded-full text-[9px] font-bold uppercase bg-amber-100 text-amber-700 cursor-help"
            title={`DMP original: ${modification.originalValue || '(empty)'}`}
          >
            Modified
          </span>
        )}
      </div>
      <p className={`text-sm ${mono ? 'font-mono font-medium text-slate-800' : 'text-slate-700'}`}>{value}</p>
      {modification && (
        <p className="text-[11px] text-amber-600 mt-0.5">
          DMP: {modification.originalValue || '(empty)'}
        </p>
      )}
    </div>
  );
}
